export const AcceptIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 12.4597L11 15L16 9" stroke="#8BFF51" stroke-width="1.33601" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export const RejectIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 9L14.9997 15" stroke="#FF552F" stroke-width="1.33601" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 9L9.00033 15" stroke="#FF552F" stroke-width="1.33601" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
